import bgVideo from '../assets/hero.mp4'
import heroImg from '../assets/images/hero.svg'
import Countdown from 'react-countdown';
import { motion } from "framer-motion";
import Counter from './features/Counter';
import { useEffect, useState } from 'react';
import logoImg from '../assets/images/Logopc.png'
import logoImgMobile from '../assets/images/logomobile.png'


const Completionist = () => <span>Released!</span>;

// Renderer callback with condition
const renderer = (props) => {
    console.log('props', props)
    if (props.completed) {
        // Render a completed state
        return <Completionist />;
    } else {
        // Render a countdown
        return <div>
            <div className='flex w-[250px]'>

                <div>
                    <div className='countdown_above'>DAY</div>
                    <div>{props.formatted.days}:</div>
                </div>
                <div>
                    <div className='countdown_above'>HRS</div>
                    <div>{props.formatted.hours}:</div>
                </div>
                <div>
                    <div className='countdown_above'>MIN</div>
                    <div>{props.formatted.minutes}:</div>
                </div>
                <div>
                    <div className='countdown_above'>SEC</div>
                    <div>{props.formatted.seconds}</div>
                </div>
            </div>
        </div>
    }
};




const Hero = () => {
    const [textIndex, setTextIndex] = useState(0);
    const [displayText, setDisplayText] = useState({ line1: '', line2: '' });
    const texts = [
        {
            line1: "First of its kind",
            line2: "on Abstract Blockchain"
        },
        {
            line1: "Supports diverse",
            line2: "digital assets"
        },
        {
            line1: "Empowering community",
            line2: "with Defi"
        },
        {
            line1: "Security and",
            line2: "performance combined"
        }
    ];

    const scrambleText = (originalText, progress) => {
        const characters = '0123456789()';
        const totalChars = originalText.length;
        const charsToReveal = Math.floor((progress / 100) * totalChars); // Convert progress to percentage
        
        // Create array of indices and shuffle them
        const indices = Array.from({ length: totalChars }, (_, i) => i);
        for (let i = indices.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [indices[i], indices[j]] = [indices[j], indices[i]];
        }
        
        // Take first N indices to reveal
        const revealIndices = new Set(indices.slice(0, charsToReveal));
        
        return originalText
            .split('')
            .map((char, index) => {
                if (revealIndices.has(index)) return char;
                if (char === ' ') return ' ';
                return characters[Math.floor(Math.random() * characters.length)];
            })
            .join('');
    };

    useEffect(() => {
        let frame = 0;
        let animationFrame;
        
        const animate = () => {
            const currentText = texts[textIndex];
            const progress = Math.min(100, frame); // Reduced from frame * 2 to frame for slower reveal
            
            setDisplayText({
                line1: scrambleText(currentText.line1, progress),
                line2: scrambleText(currentText.line2, progress)
            });

            frame++;
            
            if (progress < 100) {
                animationFrame = requestAnimationFrame(animate);
            }
        };

        frame = 0;
        animationFrame = requestAnimationFrame(animate);

        const interval = setInterval(() => {
            frame = 0;
            setTextIndex((current) => (current + 1) % texts.length);
        }, 5000);

        return () => {
            clearInterval(interval);
            cancelAnimationFrame(animationFrame);
        };
    }, [textIndex]);

    const animation = (delay, xStart, xEnd, yStart, yEnd) => {
        const result = {
            initial: { opacity: 0, x: xStart, y: yStart },
            whileInView: { opacity: 1, x: xEnd, y: yEnd },
            viewport: { once: true },
            transition: {
                ease: "easeInOut",
                duration: 0.5,
                delay: delay,
            }
        }
        return result;
    }



    useEffect(() => {

        const interBubble = document?.querySelector('.interactive');
        let curX = 0;
        let curY = 0;
        let tgX = 0;
        let tgY = 0;


        if (interBubble !== null) {

            function move() {
                curX += (tgX - curX) / 20;
                curY += (tgY - curY) / 20;
                interBubble.style.transform = `translate(${Math.round(curX)}px, ${Math.round(curY)}px)`;
                requestAnimationFrame(() => {
                    move();
                });
            }

            window.addEventListener('mousemove', (event) => {
                tgX = event.clientX;
                tgY = event.clientY;
            });

            move();
        }


    }, [window])



    return (
        <>
            <motion.div {...animation(0.4, 0, 0, 0, 0)} className='absolute w-full -z-10' style={{ width: '-webkit-fill-available' }}>
                {/* <img src={heroImg} width={'100%'} /> */}

                {/* <video loop autoPlay muted style={{ width: '100%', objectFit: 'initial' }} className='h-[1054px] xl:h-[778px]'>
                    <source src={bgVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                </video> */}


                <div className="gradient-bg  xl:h-[778px]">
                    <svg xmlns="http://www.w3.org/2000/svg">
                        <defs>
                            <filter id="goo">
                                <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
                                <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -8" result="goo" />
                                <feBlend in="SourceGraphic" in2="goo" />
                            </filter>
                        </defs>
                    </svg>
                    <div class="gradients-container">
                        <div class="g1"></div>
                        <div class="g2"></div>
                        <div class="g3"></div>
                        <div class="g4"></div>
                        <div class="g5"></div>
                        <div class="interactive"></div>
                    </div>
                </div>

            </motion.div>
            <div className="px-[5%]">
                <div className="flex justify-between items-center pt-10">
                    <motion.div {...animation(0.7, -50, 0, 0, 0)}>
                        <img 
                            src={logoImgMobile} 
                            alt="Private Pools Logo" 
                            className="h-[40px] hidden sm:block" 
                        />
                        <img 
                            src={logoImg} 
                            alt="Private Pools Logo Mobile" 
                            className="h-[40px] block sm:hidden" 
                        />
                    </motion.div>
                    <motion.div {...animation(0.7, 50, 0, 0, 0)} className='flex gap-6 items-end'>
                        <button 
                            className="inline-flex items-center gap-3 px-[24.59px] py-[10px] rounded-[100px] launch-button"
                            onClick={() => window.open('https://app.mondrianswap.xyz', '_blank')}
                        >
                            <div className="icon-circle">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 17L15 12L9 7" stroke="#0B1626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <span className="block sm:hidden">Launch dApp</span>
                            <span className="hidden sm:block">dApp</span>
                        </button>
                    </motion.div>
                </div>

                <div className="flex flex-col items-left justify-left text-left" style={{
                    width: '100%',
                    maxWidth: '900px',
                    margin: '0',
                    marginLeft: '0px',
                    paddingTop: '120px'
                }}>
             
                    <motion.div 
                        {...animation(0.95, 0, 0, 0, 0)} 
                        className="text-[76px] md:text-[76px] sm:text-[40px] xs:text-[32px] text-[#D6D6D6] w-full text-left relative h-[180px] sm:h-[120px]"
                        style={{
                            fontFamily: 'inherit',
                            fontWeight: 400,
                            lineHeight: '1.1',
                            letterSpacing: '-0.02em'
                        }}
                    >
                        <div 
                            className="absolute transition-opacity duration-500"
                            style={{
                                opacity: 1
                            }}
                        >
                            {displayText.line1}<br />
                            {displayText.line2}
                        </div>
                    </motion.div>
                    <motion.div 
                        {...animation(1, 0, 0, 0, 0)}
                        className="text-[16px] sm:text-[14px] mt-12 sm:mt-6 w-full text-left mb-12 sm:mb-6"
                        style={{
                            fontFamily: 'inherit',
                            opacity: 0.8,
                            letterSpacing: '0.02em',
                            fontWeight: 300,
                            lineHeight: '1.6'
                        }}
                    >
                        A creator-friendly DEX with simple, beginner-friendly DeFi tools ,<br />
                        Trade with ease using Weighted Pools, Stable Pools, and Smart Order Routing for the best prices.
                    </motion.div>
                    
                    {/* <motion.div {...animation(1.1, 0, 0, 0, 0)} className="flex gap-4 w-full">
                        <button className="px-8 py-3 bg-[#ADFFA8] rounded-full flex items-center gap-2">
                            <span className="flex items-center gap-2">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M12 16L12 8" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M8 12L12 8L16 12" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Statistics
                            </span>
                        </button>
                        <button className="px-8 py-3 bg-opacity-20 bg-white rounded-full flex items-center gap-2">
                            <span className="flex items-center gap-2">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2V2Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Documentation
                            </span>
                        </button>
                    </motion.div> */}
                </div>

                <motion.div {...animation(1, -150, 0, 0, 0)} className="flex items-center gap-2 scroll_down_text mt-10" onClick={() => window.scroll(0, 700)} >
                    SCROLL DOWN <svg width="29" height="31" viewBox="0 0 29 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_825_2304)">
                            <path d="M6.75032 6.25035L23.2495 22.7495" stroke="#F2F3F2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M6.75032 22.7496H23.2495V6.25042" stroke="#F2F3F2" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_825_2304">
                                <rect width="29" height="31" fill="white" transform="matrix(-1 0 0 1 29 0)" />
                            </clipPath>
                        </defs>
                    </svg>

                </motion.div>
            </div>

        </>
    );
};
export default Hero;
